import BaseService from "./BaseService";
import BaseFilter from './BaseFilter';

export class SellerService extends BaseService{
	constructor() {
		super('/Seller');
	}

	public deleteList(list: number[]) {
		return this.deleteListWithResourceName(list, 'delete-list')
	}

	public getAllByFilter(filter: SellerFilter) {
		return super.getAllByFilterBase(filter);
	}
}

export class SellerFilter extends BaseFilter{
	constructor(name?: string | null ) {
		super();
	
		this._name = name;
	}

	private _name?: string | null;

	public getAllParams(): {} {
		let data = Object.assign({},
			(this._name != null ? { Name: this._name } : {})

		);
		
		return data;
	};
}